import React from 'react';
import { Input } from 'antd';
import { useParams } from 'react-router';
import { FormComponentProps } from '@ant-design/compatible/es/form';
import { observer } from 'mobx-react';
import { useHistory } from 'react-router-dom';
import RedirectPreservingUTMQuery from '../../common/RedirectPreservingUTMQuery';

const TextArea = Input.TextArea;

type Props = FormComponentProps;

const PurchaseOrderSubmission = (props: Props) => {
    const params = useParams();
    const history = useHistory();

    //@ts-ignore
    const { quote_number } = params;

    return <RedirectPreservingUTMQuery to={`/my-account/quotes/${quote_number}/order-now/`} />;
};

export default observer(PurchaseOrderSubmission);
